import { BlockConfigExport } from '@tmh-website/components/blocks.types';

export const stickyBenefitsConfig: BlockConfigExport = {
  // If the block should decrease padding to the previous block if they have the some background color
  consecutiveBlockPadding: true,
  // Which fields should be populated by Strapi
  populateOptions: ['stickyBenefitsEntries'],
};
